"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.array.find-index");
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es7.array.includes");
require("core-js/modules/es6.string.includes");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default2 = exports.default = {
  props: {
    sourceDataOne: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    targetDataOne: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      searchText: '',
      sourceData: [],
      targetData: [],
      sourceOrder: [],
      targetOrder: []
    };
  },
  computed: {
    filteredSource: function filteredSource() {
      if (!this.searchText) return this.targetData;
      var searchTextLower = this.searchText.toLowerCase();
      return this.targetData.filter(function (item) {
        return item.data.toLowerCase().includes(searchTextLower);
      });
    }
  },
  mounted: function mounted() {
    this.sourceData = this.sourceDataOne;
    this.targetData = this.targetDataOne;
    //使用localstorage记忆化，打开这个页面的时候根据存储内容显示
    if (localStorage.getItem('sourceOrder')) {
      this.sourceOrder = JSON.parse(localStorage.getItem('sourceOrder'));
    }
    if (localStorage.getItem('targetOrder')) {
      this.targetOrder = JSON.parse(localStorage.getItem('targetOrder'));
    }
  },
  methods: {
    initData: function initData(data1, data2) {
      this.sourceData = data1;
      this.targetData = data2;
      console.log(data1, '888888888888888');
    },
    handleSubmitSort: function handleSubmitSort() {
      this.sourceOrder = this.sourceData.map(function (item) {
        return item.idx;
      });
      this.targetOrder = this.targetData.map(function (item) {
        return item.idx;
      });
      localStorage.setItem('sourceOrder', JSON.stringify(this.sourceOrder));
      localStorage.setItem('targetOrder', JSON.stringify(this.targetOrder));
      this.$emit('handleSubmitSort', this.sourceData);
    },
    handleButtonClose: function handleButtonClose() {
      this.$parent.transferDialogVisible = false;
    },
    handleRemoveAll: function handleRemoveAll() {
      var _this = this;
      this.sourceData.forEach(function (item) {
        _this.targetData.push(item);
      });
      this.sourceData = [];
    },
    handleAll: function handleAll() {
      var _this2 = this;
      this.targetData.forEach(function (item) {
        _this2.sourceData.push(item);
      });
      this.targetData = [];
    },
    opened: function opened() {
      this.$emit('opened');
      // this.sourceData = this.sourceDataOne
      // this.targetData = this.targetDataOne
    },
    moveToTarget: function moveToTarget(item) {
      console.log(item, 'item');
      this.sourceData = this.sourceData.filter(function (i) {
        return i.title !== item.title;
      });
      this.targetData.push(item);
      console.log(this.sourceData, ' this.sourceData');
      console.log(this.targetData, 'this.targetData');
    },
    moveToSource: function moveToSource(item) {
      this.targetData = this.targetData.filter(function (i) {
        return i.title !== item.title;
      });
      this.sourceData.push(item);
    },
    moveUp: function moveUp(item) {
      // if (this.selectedItems.length === 1) {
      var selectedItem = item;
      var index = this.sourceData.findIndex(function (item) {
        return item.title === selectedItem.title;
      });
      console.log(index, 'index');
      if (index > 0) {
        // 交换位置
        var temp = this.sourceData[index];
        this.$set(this.sourceData, index, this.sourceData[index - 1]);
        this.$set(this.sourceData, index - 1, temp);
      }
      // }
    },
    moveDown: function moveDown(item) {
      // 只有一个选中项才能下移
      //  if (this.selectedItems.length === 1) {
      var selectedItem = item;
      var index = this.sourceData.findIndex(function (item) {
        return item.title === selectedItem.title;
      });
      if (index < this.sourceData.length - 1) {
        // 交换位置
        var temp = this.sourceData[index];
        this.$set(this.sourceData, index, this.sourceData[index + 1]);
        this.$set(this.sourceData, index + 1, temp);
        // }
      }
    }
  }
};